export default function ShareIcon(){
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.60206 10.0919L16.3521 1.34194M7.70838 10.3653L9.89847 15.997C10.0914 16.4931 10.1879 16.7412 10.3269 16.8136C10.4474 16.8764 10.5909 16.8765 10.7115 16.8138C10.8506 16.7416 10.9473 16.4936 11.1409 15.9977L16.6328 1.92461C16.8075 1.47696 16.8948 1.25313 16.8471 1.11011C16.8056 0.9859 16.7081 0.888426 16.5839 0.846933C16.4409 0.799153 16.217 0.886499 15.7694 1.06119L1.69627 6.55314C1.20038 6.74666 0.95243 6.84342 0.880172 6.98251C0.817532 7.10308 0.817617 7.24662 0.880398 7.36712C0.95282 7.50613 1.20088 7.60259 1.697 7.79553L7.32867 9.98562C7.42938 10.0248 7.47973 10.0444 7.52213 10.0746C7.55971 10.1014 7.59258 10.1343 7.61939 10.1719C7.64963 10.2143 7.66921 10.2646 7.70838 10.3653Z"
        stroke="#335015"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}